import { Controller } from "@hotwired/stimulus"
import { DragDropManager } from "@dnd-kit/dom"
import { Sortable } from "@dnd-kit/dom/sortable"
import { RestrictToVerticalAxis } from '@dnd-kit/abstract/modifiers';

// Connects to data-controller="drag-drop"
export default class extends Controller {
  static targets = ["element"]

  connect() {
    this.manager = new DragDropManager({
      modifiers: [RestrictToVerticalAxis]
    })

    this.elementTargets.forEach((element, index) => {
      new Sortable({ id: element.id, index, element }, this.manager)
    })
  }

  // dnd-kit doesn't expose functions to move elements manually, but
  // we can simulate keyboard events to accomplish this instead
  moveUp(event) {
    const button = event.currentTarget
    const element = this.findElementForButton(button)
    if (!element) return

    this.simulateKeyboardMovement(element, 'ArrowUp')
  }

  moveDown(event) {
    const button = event.currentTarget
    const element = this.findElementForButton(button)
    if (!element) return

    this.simulateKeyboardMovement(element, 'ArrowDown')
  }

  findElementForButton(button) {
    // Find the sortable element that contains this button
    return button.closest('[data-drag-drop-target="element"]')
  }

  simulateKeyboardMovement(element, arrowKey) {
    // Focus the element first
    element.focus()

    // Simulate pressing Space to start dragging
    this.dispatchKeyboardEvent(element, 'keydown', 'Space')

    // Small delay to ensure drag has started
    setTimeout(() => {
      // Simulate the arrow key to move
      this.dispatchKeyboardEvent(element, 'keydown', arrowKey)

      // Small delay then simulate Space again to drop
      setTimeout(() => {
        this.dispatchKeyboardEvent(element, 'keydown', 'Space')
      }, 50)
    }, 50)
  }

  dispatchKeyboardEvent(element, type, key) {
    const event = new KeyboardEvent(type, {
      key: key,
      code: key,
      bubbles: true,
      cancelable: true
    })

    element.dispatchEvent(event)
  }
}